import React,{useState,useRef} from 'react'
import DatePicker from 'react-date-picker';
import ReactToPrint from 'react-to-print';
import {ComponentToPrint} from './Print';
import ReactToExcel from 'react-html-table-to-excel';

function Rquantidade() {
    const [step,setStep]=useState({iva:"",m3:"",valg:"",tsc:"",mpag:""});
  const [value, SonChange] = useState(new Date());
  const [fvalue, fSonChange] = useState(new Date());
  const printChart = useRef(null);
  const Send=()=>{

}
  return (
    <div>
        <h5>Relatorio Estatistico > Volume adquirido</h5>
        <div className='nopias'>
         <div className='Filtrar_i'>
               <div className='NP'>
                {/*Provincia*/}
               <div>
               Provincia
               <select id="combo" onChange={(e)=>{
                         const provincia=e.target.value;
                         step.mpag=provincia;
                         }}>
                          
                          <option value="NUM">---</option>
                           
                            <option value="maputo">Maputo</option>
                            <option value="nampula">Nampula</option>
                                       </select>

               </div>
                {/*Cidade*/}
                <div>
                Cidade
                <select id="combo" onChange={(e)=>{
                         const provincia=e.target.value;
                         step.mpag=provincia;
                         }}>
                           
                           <option value="NUM">---</option>
                           
                            <option value="nampula">Nampula</option>
                            <option value="maputo">Maputo </option>
                            <option value="matola">Matola</option>
                          
                                       </select>
                </div>
                 {/*Bairro */}
                 <div>
                  Bairro
                  <select id="combo" onChange={(e)=>{
                         const provincia=e.target.value;
                         step.mpag=provincia;
                         }}>
                          
                          <option value="NUM">---</option>
                           
                            <option value="ubc">Urbano Central</option>
              
                                       </select>
                 </div>
                {/*Vila*/}

                <div>
                  Vila <select id="combo" onChange={(e)=>{
                         const provincia=e.target.value;
                         step.mpag=provincia;
                         }}>
                            <option value="NUM">---</option>
                           
                            <option value="NUM">Bombeiros</option>
                            <option value="MPESA">25 de Setembro</option>
                            <option value="MMOLA">1º de Maio</option>
                            <option value="MP24">Limoeiros</option>
                           
                                       </select>
                </div>
                <div>
                  Intervalo
                  <DatePicker className='datepicke' onChange={SonChange} value={value} />
                </div>
                  <div>
                    Fim
                  <DatePicker className='datepicke' onChange={fSonChange} value={fvalue}/>
                  </div>
               </div>

               <div className='NP'>
                {/*Provincia*/}
               <div>
                Empresa
               <select id="combo" onChange={(e)=>{
                         const provincia=e.target.value;
                         step.mpag=provincia;
                         }}>
                          
                          <option value="NUM">---</option>
                           
                            <option value="fpnampula">FIPAG-Nampula</option>
                                       </select>

               </div>
                {/*Cidade*/}
                <div>
                Agencia
                <select id="combo" onChange={(e)=>{
                         const provincia=e.target.value;
                         step.mpag=provincia;
                         }}>
                           
                           <option value="NUM">---</option>
                           
                            <option value="nampula">Cidade de Nampula</option>
                           
                                       </select>
                </div>
                 {/*Bairro */}
                 <div>
                  IdUsario
                  <select id="combo" onChange={(e)=>{
                         const provincia=e.target.value;
                         step.mpag=provincia;
                         }}>
                          
                          <option value="NUM">---</option>
                           
                            <option value="ubc">1</option>
                            <option value="ubc">2</option>
                            <option value="ubc">3</option>
              
                                       </select>
                 </div>
                {/*Vila*/}

                 </div>
          <>
          <div className='tabela_consumo'>
            <table id='tabela_consumos_i'>
            <thead>
      <tr>
        <th>Numero do Cliente</th>
        <th>Numero do Contador</th>
        <th>Numero da Compra</th>
        <th>Nome da Provincia</th>
        <th>Nome da cidade</th>
        <th>Nome da Distrito</th>
        <th>Nome da Bairro</th>  
        <th>Volume total em m3</th>
        <th>Volume total em Mzn</th>
       
      </tr>
    </thead>
    <tbody> 
 <tr> 
    <td>10118</td>
         <td>44455465465</td>
         <td>19190</td>
         <td>Maputo</td>
         <td>Cidade de Maputo</td>
         <td>Kamubuane</td>
        
         <td>Magoanine B</td>
         <td>500</td>
         <td>25000</td>
         </tr>


     </tbody>

            </table>
          </div>
          <> <img  id="imagem"src={require('./images/printer.png')}  />
          <ReactToPrint
          trigger={() => {
             return <a  href="#">   
             <button  id="opcao" value="Nao" onClick={Send} >Imprimir
             </button>
 </a>;
          }}
          content={() => printChart.current}
        />
          <img  id="imagem"src={require('./images/excel.png')}  />
          <ReactToExcel 
                    id='opcao'
                    table='tabela_consumos_i'
                    filename='Relatorios_de_consumo'
                    sheet='sheet 1'
                    buttonText='Exportar'/>
          </>
          <div>
          <ComponentToPrint ref={printChart}>
            <div className='Relatorio_para_Impressao'>
            <h5>Relatorio Estatistico Volume Consumido</h5>
            <label>Data de Impressao:</label>
            <div><label>Inicio:15/08/2022</label>
            <label>Fim:05/09/2022</label>
            </div>
            <div className='tabela_cnsumo'>
            <table id='tabela_consumos_i'>
            <thead>
      <tr>
        <th>Numero do Cliente</th>
        <th>Numero do Contador</th>
        <th>Numero da Compra</th>
        <th>Nome da Provincia</th>
        <th>Nome da cidade</th>
        <th>Nome da Distrito</th>
        <th>Nome da Bairro</th>  
        <th>Volume total em m3</th>
        <th>Volume total em MZN</th>
      
      </tr>
    </thead>
    <tbody>  <tr> 
    <td>10118</td>
         <td>44455465465</td>
         <td>19190</td>
         <td>Maputo</td>
         <td>Cidade de Maputo</td>
         <td>Kamubuane</td>
        
         <td>Magoanine B</td>
         <td>10</td>
         <td>500</td>
      
         </tr>

         <tr> 
    <td>10118</td>
         <td>44455465465</td>
         <td>19190</td>
         <td>Maputo</td>
         <td>Cidade de Maputo</td>
         <td>Kamubuane</td>
        
         <td>Magoanine B</td>
         <td>60</td>
         <td>3000</td>
      
         </tr><tr> 
    <td>10118</td>
         <td>44455465465</td>
         <td>19190</td>
         <td>Maputo</td>
         <td>Cidade de Maputo</td>
         <td>Kamubuane</td>
        
         <td>Magoanine B</td>
         <td>100</td>
         <td>5000</td>
      
         </tr><tr> 
    <td>10118</td>
         <td>44455465465</td>
         <td>19190</td>
         <td>Maputo</td>
         <td>Cidade de Maputo</td>
         <td>Kamubuane</td>
        
         <td>Magoanine B</td>
         <td>40</td>
         <td>2000</td>
      
         </tr><tr> 
    <td>10118</td>
         <td>44455465465</td>
         <td>19190</td>
         <td>Maputo</td>
         <td>Cidade de Maputo</td>
         <td>Kamubuane</td>
        
         <td>Magoanine B</td>
         <td>70</td>
         <td>3500</td>
      
         </tr><tr> 
    <td>10118</td>
         <td>44455465465</td>
         <td>19190</td>
         <td>Maputo</td>
         <td>Cidade de Maputo</td>
         <td>Kamubuane</td>
        
         <td>Magoanine B</td>
         <td>20.2</td>
         <td>1010</td>
      
         </tr><tr> 
    <td>10118</td>
         <td>44455465465</td>
         <td>19190</td>
         <td>Maputo</td>
         <td>Cidade de Maputo</td>
         <td>Kamubuane</td>
        
         <td>Magoanine B</td>
         <td>10</td>
         <td>500</td>
      
         </tr>


     </tbody>

            </table>
          </div>

            </div>
         </ComponentToPrint>
          
          </div>
          </>     

         </div>


          </div>
    </div>
  )
}

export default Rquantidade